<template>
  <layout-vertical :nav-menu-items="navMenuItems">

    <router-view />
   
  <div
      slot="breadcrumb"
      class="p-1"
    >
    
        <h5 style="text-align:center" v-if="userData.role=='Student'">
          {{ userData.fullName  }}
          <br>{{userData.className}} 

        </h5>
      <!-- I am custom breadcrumb ver -->
    </div>

   

  </layout-vertical>
</template>

<script>

import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import navMenuItems from '@/navigation/vertical'

// import useVerticalNavMenu from '@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu'

import {
  BLink, BNavbarNav,
    BCard,
    BCardText, 
} from 'bootstrap-vue'
import Bookmarks from '@core/layouts/components/app-navbar/components/Bookmarks.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import SearchBar from '@core/layouts/components/app-navbar/components/SearchBar.vue'
import CartDropdown from '@core/layouts/components/app-navbar/components/CartDropdown.vue'
import NotificationDropdown from '@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import UserDropdown from '@core/layouts/components/app-navbar/components/UserDropdown.vue'

export default {
  components: {
    BLink,

    BCard,
    BCardText, //BButton,
    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    DarkToggler,
    SearchBar,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,

    // AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      // showCustomizer: $themeConfig.layout.customizer,
      navMenuItems,
    }
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
